import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_image_1Id, id_image_1Alt, id_image_1Opacite, id_image_1Afficher, id_image_2Id, id_image_2Alt, id_image_2Opacite, id_image_2Afficher, id_image_3Id, id_image_3Alt, id_image_3Opacite, id_image_3Afficher, id_bouton_1Texte, id_bouton_1Url, id_bouton_1CouleurFond, id_bouton_1CouleurTexte, id_bouton_1CouleurBordure, id_bouton_1CouleurFondHover, id_bouton_1CouleurTexteHover, id_bouton_1CouleurBordureHover, id_bouton_1CouleurFondActive, id_bouton_1CouleurTexteActive, id_bouton_1CouleurBordureActive, id_bouton_1Opacite, id_bouton_1Afficher, id_bouton_1_texte_1Texte, id_bouton_1_texte_1CouleurTexte, id_bouton_1_texte_1Opacite, id_bouton_1_texte_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_image_1ImageUrl, id_image_2ImageUrl, id_image_3ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_image_1ImageUrl: id_image_1Id ? media.getMedia( id_image_1Id )?.source_url : null,
            id_image_2ImageUrl: id_image_2Id ? media.getMedia( id_image_2Id )?.source_url : null,
            id_image_3ImageUrl: id_image_3Id ? media.getMedia( id_image_3Id )?.source_url : null
        };
    }, [ blocImageFondId, id_image_1Id, id_image_2Id, id_image_3Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{`
        .id_bouton_1:hover {
            background-color: ${id_bouton_1CouleurFondHover} !important;
            color: ${id_bouton_1CouleurTexteHover} !important;
            border-color: ${id_bouton_1CouleurBordureHover} !important;
        }
        .id_bouton_1:active {
            background-color: ${id_bouton_1CouleurFondActive} !important;
            color: ${id_bouton_1CouleurTexteActive} !important;
            border-color: ${id_bouton_1CouleurBordureActive} !important;
        }`}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_1Afficher}
                        onChange={(val) => setAttributes({ id_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_1Alt}
                            onChange={(val) => setAttributes({ id_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_1Opacite}
                        onChange={(val) => setAttributes({ id_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_2Afficher}
                        onChange={(val) => setAttributes({ id_image_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_2Alt}
                            onChange={(val) => setAttributes({ id_image_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_2Opacite}
                        onChange={(val) => setAttributes({ id_image_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-3 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_3Afficher}
                        onChange={(val) => setAttributes({ id_image_3Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_3Alt}
                            onChange={(val) => setAttributes({ id_image_3Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_3Opacite}
                        onChange={(val) => setAttributes({ id_image_3Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-1 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_1Afficher}
                        onChange={(val) => setAttributes({ id_bouton_1Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_bouton_1Url}
                            onChange={(url) => setAttributes({ id_bouton_1Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_bouton_1CouleurFond} onChange={(val) => setAttributes({ id_bouton_1CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_bouton_1CouleurTexte} onChange={(val) => setAttributes({ id_bouton_1CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_bouton_1CouleurBordure} onChange={(val) => setAttributes({ id_bouton_1CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_bouton_1CouleurFondHover} onChange={(val) => setAttributes({ id_bouton_1CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_bouton_1CouleurTexteHover} onChange={(val) => setAttributes({ id_bouton_1CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_bouton_1CouleurBordureHover} onChange={(val) => setAttributes({ id_bouton_1CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_bouton_1CouleurFondActive} onChange={(val) => setAttributes({ id_bouton_1CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_bouton_1CouleurTexteActive} onChange={(val) => setAttributes({ id_bouton_1CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_bouton_1CouleurBordureActive} onChange={(val) => setAttributes({ id_bouton_1CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_1Opacite}
                        onChange={(val) => setAttributes({ id_bouton_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_bouton_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_bouton_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_bouton_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_bouton_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            {/* id_image_1 */}
                            {id_image_1Afficher && (
                                <MediaUpload
                                    onSelect={(media) => setAttributes({ id_image_1Id: media.id, id_image_1Alt: media.alt })}
                                    type="image"
                                    value={id_image_1Id}
                                    render={({ open }) => (
                                        <div onClick={open} style={{ cursor: 'pointer' }}>
                                            {id_image_1ImageUrl ? (
                                                <img className="id_image_1" src={id_image_1ImageUrl} alt={id_image_1Alt} style={{ opacity: id_image_1Opacite }} />
                                            ) : (
                                                <Button variant="secondary">Ajouter une image</Button>
                                            )}
                                        </div>
                                    )}
                                />
                            )}
                            {/* end-id_image_1 */}
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            {/* id_image_2 */}
                            {id_image_2Afficher && (
                                <MediaUpload
                                    onSelect={(media) => setAttributes({ id_image_2Id: media.id, id_image_2Alt: media.alt })}
                                    type="image"
                                    value={id_image_2Id}
                                    render={({ open }) => (
                                        <div onClick={open} style={{ cursor: 'pointer' }}>
                                            {id_image_2ImageUrl ? (
                                                <img className="id_image_2" src={id_image_2ImageUrl} alt={id_image_2Alt} style={{ opacity: id_image_2Opacite }} />
                                            ) : (
                                                <Button variant="secondary">Ajouter une image</Button>
                                            )}
                                        </div>
                                    )}
                                />
                            )}
                            {/* end-id_image_2 */}
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            {/* id_image_3 */}
                            {id_image_3Afficher && (
                                <MediaUpload
                                    onSelect={(media) => setAttributes({ id_image_3Id: media.id, id_image_3Alt: media.alt })}
                                    type="image"
                                    value={id_image_3Id}
                                    render={({ open }) => (
                                        <div onClick={open} style={{ cursor: 'pointer' }}>
                                            {id_image_3ImageUrl ? (
                                                <img className="id_image_3" src={id_image_3ImageUrl} alt={id_image_3Alt} style={{ opacity: id_image_3Opacite }} />
                                            ) : (
                                                <Button variant="secondary">Ajouter une image</Button>
                                            )}
                                        </div>
                                    )}
                                />
                            )}
                            {/* end-id_image_3 */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 offset-md-4 col-md-4 text-center">
                            {/* id_bouton_1 */}
                            {id_bouton_1Afficher && (
                                <a 
                                    className="btn id_bouton_1"
                                    role="button"
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                        backgroundColor: id_bouton_1CouleurFond,
                                        color: id_bouton_1CouleurTexte,
                                        borderColor: id_bouton_1CouleurBordure,
                                        opacity: id_bouton_1Opacite,
                                        cursor: 'default'
                                    }}
                                >
                                    <RichText
                                        tagName="span"
                                        value={id_bouton_1Texte}
                                        onChange={(val) => setAttributes({ id_bouton_1Texte: val })}
                                        placeholder="Texte du bouton..."
                                    />
                                </a>
                            )}
                            {/* end-id_bouton_1 */}
                        </div>
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}